import { render, staticRenderFns } from "./bankAccounts.vue?vue&type=template&id=0e60d238"
import script from "./bankAccounts.vue?vue&type=script&lang=js"
export * from "./bankAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports